export function russianPluralRule(choice, choicesLength) {
  if (choicesLength !== 3) return 0;
  const value = Math.abs(choice);
  const mod10 = value % 10;
  const mod100 = value % 100;
  if (mod10 === 1 && mod100 !== 11) return 0;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 1;
  return 2;
}

export function normalizeTranslationCount(value) {
  const normalizedValue = String(value ?? '').replace(/[\s\u00a0\u202f]/g, '');
  const count = Number(normalizedValue);

  return Number.isFinite(count) ? count : 0;
}

export function translatePlural(translate, key, value, params = {}) {
  const count = normalizeTranslationCount(value);
  return translate(key, count, { ...params, count });
}

export function localizeCountedStats(stats, translate, keyPrefix = 'home.stats') {
  return (Array.isArray(stats) ? stats : []).map((stat) => {
    const count = normalizeTranslationCount(stat?.value);

    return {
      ...stat,
      label: translatePlural(translate, `${keyPrefix}.${stat.key}`, count),
    };
  });
}
